import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";

const messages = defineMessages({
  initialSetup1: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step1",
    defaultMessage: "Calendar sync",
  },
  initialSetup1Description: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step1.description",
    defaultMessage:
      "Set up the calendar sync here to have MMC Activities sync with your external calendar.",
  },
  initialSetup2: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step2",
    defaultMessage: "Email sync",
  },
  initialSetup2Description: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step2.description",
    defaultMessage:
      "Use this setting to connect an email address to use for sending emails from the application.",
  },
  initialSetup3: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step3",
    defaultMessage: "Notifications",
  },
  initialSetup3Description: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step3.description",
    defaultMessage: "Set up email notifications options on this page.",
  },
  initialSetup4: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step4",
    defaultMessage: "Notifications",
  },
  initialSetup4Description: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step4.description",
    defaultMessage: "This is the notifications center, click the bell icon to proceed.",
  },
  initialSetup5: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step5",
    defaultMessage: "Notifications",
  },
  initialSetup5Description: {
    id: "guides.gettingStarted.checklist.initialSetup.reps.step5.description",
    defaultMessage:
      "Any notifications you have set can be found here, such as mentions or overdue activities.",
  },
});

export const repsInitialSetupTour: TourDescriptor = {
  id: "getting-started-reps-initial-setup",
  steps: [
    {
      id: "cal-sync",
      description: messages.initialSetup1Description,
      position: "right",
      selector: "[data-element-id=settings-page-title]",
      title: messages.initialSetup1,
    },
    {
      id: "email-sync",
      description: messages.initialSetup2Description,
      goToPathBefore: "/settings/personal/email-preferences",
      selector: "[data-element-id=settings-page-title]",
      title: messages.initialSetup2,
    },
    {
      id: "notification-settings",
      description: messages.initialSetup3Description,
      goToPathBefore: "/settings/privacy/notifications",
      selector: "[data-element-id=settings-page-title]",
      title: messages.initialSetup3,
    },
    {
      id: "notifications-button",
      description: messages.initialSetup4Description,
      options: {
        disableInteraction: false,
        showButtons: false,
      },
      selector: "[data-action-id=notification-center]",
      title: messages.initialSetup4,
      waitForEvent: {
        eventType: "click",
        selector: "[data-action-id=notification-center]",
      },
    },
    {
      id: "notifications-center",
      description: messages.initialSetup5Description,
      onAfter: async () => {
        (document.querySelector("[data-action-id=notification-center]") as HTMLElement)?.click();
      },
      selector: ".ant-popover[class*=Notifications_container]",
      title: messages.initialSetup5,
    },
  ],
};
